<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t(`iamee.organization.add_${params.type}`)}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('iamee.node')" :count="params.data.length" :action="$t(`iamee.organization.add_${params.type}`)" />
      <dialog-table :data="params.data" :columns="params.columns" />
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="params.name" prop="target_id">
          <list-select
            v-model="form.target_id"
            :listProps="resourceProps"
            :dialog-params="{ mask: false, width: 900, title: $t(`dictionary.${params.type}`) }"
            @change="resourceSelected" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import ListSelect from '@/sections/ListSelect'
import { validateModelForm } from '@/utils/validate'
import { getNameFilter, getDescriptionFilter, getProjectDomainFilter } from '@/utils/common/tableFilter'
import { getProjectDomainTableColumn } from '@/utils/common/tableColumn'

export default {
  name: 'OrganizationBindDialog',
  components: {
    ListSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { type } = this.params
    return {
      form: {
        target_id: [],
        type,
      },
      rules: {
        target_id: { validator: this.targetValidator },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    resourceProps () {
      let resource = 'domains'
      const projectFilter = {}
      const projectColumns = []
      if (this.params.type === 'project') {
        resource = 'projects'
        projectFilter.project_domain = getProjectDomainFilter()
        projectColumns.push(getProjectDomainTableColumn())
      }
      return {
        list: this.$list.createList(this, {
          resource,
          apiVersion: 'v1',
          getParams: () => {
            return {
              scope: this.$store.getters.scope,
            }
          },
          filterOptions: {
            name: getNameFilter(),
            description: getDescriptionFilter(),
            ...projectFilter,
          },
        }),
        columns: [
          {
            field: 'name',
            title: this.$t('table.title.name'),
            showOverflow: 'title',
          },
          ...projectColumns,
        ],
      }
    },
  },
  created () {
    this.$oM = new this.$Manager('organization_nodes', 'v1')
  },
  methods: {
    resourceSelected (val) {
      this.form.target_id = val
    },
    targetValidator (rule, value, callback) {
      if (!this.form.target_id.length) {
        callback(new Error(this.$t('common.tips.select', [this.params.name])))
      }
      callback()
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.$oM.performAction({
          id: this.params.data[0].id,
          action: 'bind',
          data: {
            target_id: this.form.target_id,
            resource_type: this.form.type,
          },
        })
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
